import { getOutboundMessage } from './outboundUtils';
export function createInitMttStagingOutbound() {
    return getOutboundMessage({ _type: 'init_chat' });
}
export function createMttStagingChatOutbound(message) {
    return getOutboundMessage({ _type: 'cc', parts: [{ name: 'message', stringValue: message }] });
}
export function createExitMttStagingToLoungeOutbound(loungeId = 0) {
    return getOutboundMessage({
        _type: 'clounge',
        parts: [{ name: 'loungeId', numberValue: loungeId }]
    });
}
export function createRequestMttStagingToggleReadyOutbound(hasConfirmedReady) {
    return getOutboundMessage({
        _type: 'mtt_request_toggle_ready',
        parts: [{ name: 'hasConfirmedReady', booleanValue: hasConfirmedReady }]
    });
}
export function createMttUserStartOutbound() {
    return getOutboundMessage({ _type: 'mtt_user_start' });
}
